var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AccountUtils from '@popup/steem/utils/account.utils';
import { SteemTxUtils } from '@popup/steem/utils/steem-tx.utils';
import { PrivateKey, } from '@steempro/dsteem';
export var AccountCreationType;
(function (AccountCreationType) {
    AccountCreationType["USING_TICKET"] = "USING_TICKET";
    AccountCreationType["BUYING"] = "BUYING";
})(AccountCreationType || (AccountCreationType = {}));
const checkAccountNameAvailable = (username) => __awaiter(void 0, void 0, void 0, function* () {
    const account = yield AccountUtils.getExtendedAccount(username);
    return account ? false : true;
});
const generateMasterKey = () => {
    const array = new Uint32Array(10);
    crypto.getRandomValues(array);
    return 'P' + PrivateKey.fromSeed(array.toString()).toString();
};
const validateUsername = (username) => {
    return new RegExp(/^(?=.{3,16}$)[a-z]([0-9a-z]|[0-9a-z\-](?=[0-9a-z])){2,}([\.](?=[a-z][0-9a-z\-][0-9a-z\-])[a-z]([0-9a-z]|[0-9a-z\-](?=[0-9a-z])){1,}){0,}$/).test(username);
};
const createAccount = (creationType, newUsername, parentUsername, parentActiveKey, authorities, price, generatedKeys, options) => __awaiter(void 0, void 0, void 0, function* () {
    let success = null;
    switch (creationType) {
        case AccountCreationType.BUYING: {
            success = yield createPayingAccount(authorities, newUsername, parentUsername, parentActiveKey, price, options);
            break;
        }
        case AccountCreationType.USING_TICKET: {
            success = yield createAccountUsingTicket(authorities, newUsername, parentUsername, parentActiveKey, options);
            break;
        }
    }
    if (success && generatedKeys) {
        return {
            name: newUsername,
            keys: {
                active: generatedKeys.active.private,
                activePubkey: generatedKeys.active.public,
                posting: generatedKeys.posting.private,
                postingPubkey: generatedKeys.posting.public,
                memo: generatedKeys.memo.private,
                memoPubkey: generatedKeys.memo.public,
            },
        };
    }
    else {
        return false;
    }
});
const createAccountUsingTicket = (authorities, newUsername, parentUsername, parentActiveKey, options) => {
    return SteemTxUtils.sendOperation([
        AccountCreationUtils.getCreateClaimedAccountOperation(authorities, newUsername, parentUsername),
    ], parentActiveKey, false, options);
};
/* istanbul ignore next */
const getCreateClaimedAccountOperation = (authorities, newUsername, parentUsername) => {
    const extensions = [];
    return [
        'create_claimed_account',
        Object.assign({ creator: parentUsername, new_account_name: newUsername, json_metadata: '{}', extensions: extensions }, authorities),
    ];
};
/* istanbul ignore next */
const getCreateClaimedAccountTransaction = (authorities, newUsername, parentUsername) => {
    return SteemTxUtils.createTransaction([
        AccountCreationUtils.getCreateClaimedAccountOperation(authorities, newUsername, parentUsername),
    ]);
};
const createPayingAccount = (authorities, newUsername, parentUsername, parentActiveKey, price, options) => {
    return SteemTxUtils.sendOperation([
        [
            'account_create',
            Object.assign({ fee: `${price.toFixed(3)} STEEM`, creator: parentUsername, new_account_name: newUsername, json_metadata: '{}' }, authorities),
        ],
    ], parentActiveKey, false, options);
};
/* istanbul ignore next */
const generateAccountAuthorities = (keys) => {
    return {
        owner: {
            weight_threshold: 1,
            account_auths: [],
            key_auths: [[keys.owner.public, 1]],
        },
        active: {
            weight_threshold: 1,
            account_auths: [],
            key_auths: [[keys.active.public, 1]],
        },
        posting: {
            weight_threshold: 1,
            account_auths: [],
            key_auths: [[keys.posting.public, 1]],
        },
        memo_key: keys.memo.public,
    };
};
/* istanbul ignore next */
const setRecoveryAccountOperation = (accountName, newRecoveryAccount, ownerKey, options) => {
    return SteemTxUtils.sendOperation([
        [
            'change_recovery_account',
            {
                account_to_recover: accountName,
                new_recovery_account: newRecoveryAccount,
                extensions: [],
            },
        ],
    ], ownerKey, false, options);
};
export const AccountCreationUtils = {
    checkAccountNameAvailable,
    generateMasterKey,
    validateUsername,
    createAccount,
    setRecoveryAccountOperation,
    generateAccountAuthorities,
    getCreateClaimedAccountOperation,
    getCreateClaimedAccountTransaction,
};
